module.exports = __webpack_public_path__ + "img/body-img.4f784f49.png";